import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from 'reactstrap';

const NewLeagueScheduleModal = ({ isOpen, toggle, onSave, leagueId }) => {
  const [newSchedule, setNewSchedule] = useState({
    league: leagueId,
    title: '',
    sort_order: 99
  });

  const handleSave = () => {
    onSave(newSchedule);
    setNewSchedule({ league: leagueId, title: '', sort_order: 99 });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewSchedule(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add New Schedule</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="title">Schedule Title *</Label>
          <Input
            type="text"
            id="title"
            name="title"
            value={newSchedule.title}
            onChange={handleChange}
            placeholder="e.g., Monday Night, Flight A"
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="sort_order">Sort Order</Label>
          <Input
            type="number"
            id="sort_order"
            name="sort_order"
            value={newSchedule.sort_order}
            onChange={handleChange}
            placeholder="99"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!newSchedule.title}>
          Add Schedule
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NewLeagueScheduleModal;
